import { PopUpType } from '@/domain/enums/pop-up-type';
import globalStore from '@/store/global';
import globals from '@/utils/globals';
import { StructEvent } from '@/utils/tracking/events/struct';
import Actions from '@/dictionary/tracking/actions';
import { IncentiveBase } from '../incentive-base.class';
import { Referrer } from 'interfaces';

export default class OptIn extends IncentiveBase {
	private identifier?: PopUpType;
	mounted(): void {
		this.setOpenPopUpListener();
	}

	public async accept(): Promise<void> {
		if (this.identifier === PopUpType.EXPERIMENT_C_OPT_IN_POP_UP) {
			await globalStore.actions.acceptOptIn(undefined, true);
			return;
		}

		await globalStore.actions.acceptOptIn();
	}

	public notNow(): void {
		if (this.identifier === PopUpType.EXPERIMENT_C_OPT_IN_POP_UP) {
			globals.cpiModalPlugin.renderCPIModal();
		}

		globalStore.actions.denyOptIn();
	}

	public trackImpression(): void {
		const referrer = this.incentiveStore.getters.referrer();
		globals.authenticationServiceTracking.track(
			new StructEvent(
				{
					action: Actions.OPTIN_IMPRESSION,
					// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
					label: `${referrer}:${globalStore.getters.portalType()}`,
				},
				referrer,
			),
			true,
			true,
		);
	}
	private setOpenPopUpListener(): void {
		globals.eventBus.on('openPopup', (params: any) => {
			const { identifier, referrer } = params as { identifier: PopUpType; referrer: Referrer };
			this.incentiveStore.mutations.setReferrer(referrer);
			this.identifier = identifier;

			if (identifier === PopUpType.OPT_INT_POP_UP ||
				identifier === PopUpType.EXPERIMENT_A_OPT_IN_POP_UP ||
				identifier === PopUpType.EXPERIMENT_C_OPT_IN_POP_UP
			) {
				this.trackImpression();
			}
		});
	}
}
